export default "__VITE_ASSET__2mAUDvXR__"